import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { EventDetailsComponent, SchedulesService } from '@libs/schedule';
import { TranslateModule } from '@ngx-translate/core';
import { EVENT_DETAILS_SIDEBAR_EVENT } from './event-details-sidebar-token';

@Component({
  selector: 'lib-event-details-sidebar',
  templateUrl: './event-details-sidebar.component.html',
  styleUrls: ['./event-details-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [EventDetailsComponent, SvgIconComponent, TranslateModule],
})
export class EventDetailsSidebarComponent {
  protected readonly selectedEvent = inject(EVENT_DETAILS_SIDEBAR_EVENT);
  private readonly schedulesService = inject(SchedulesService);

  public onCloseClick(): void {
    this.schedulesService.removeAppointmentSelection();
  }
}
